import styled, { keyframes, css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint } from 'react-components'

const borderSpin = keyframes`
    from { transform: translate(-50%, -50%) rotate(0deg); }
    to   { transform: translate(-50%, -50%) rotate(360deg); }
`

export const ListContainer = styled.div`
    position: relative;
    max-width: 100%;
`

export const CardsRow = styled.div`
    display: flex;
    gap: 1rem;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    padding: 0.5rem 1rem;

    &::-webkit-scrollbar {
        display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        gap: 1.5rem;
        padding: 0.5rem 0.5rem 0.5rem 0;
    }
`

export const CardBorderWrapper = styled.div<{ $isLoading?: boolean }>`
    display: flex;
    flex: 0 0 12.5rem;
    border-radius: 0.75rem;
    position: relative;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
        flex: 0 0 13.125rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        flex: 1;
        min-width: 0;
        max-width: calc(20% - 1.2rem);
    }

    ${({ $isLoading }) =>
        $isLoading &&
        css`
            padding: 0.125rem;
            overflow: hidden;
            background: #d0d0d0;

            &::before {
                content: '';
                position: absolute;
                width: 300%;
                height: 300%;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(0deg);
                background: conic-gradient(
                    from 0deg,
                    transparent 0deg,
                    transparent 340deg,
                    rgba(0, 0, 0, 0.3) 350deg,
                    #000000 357deg,
                    #000000 360deg
                );
                animation: ${borderSpin} 1.5s linear infinite;
                z-index: 0;
            }
        `}
`

export const CardContainer = styled.button`
    background: white;
    border: 0.0625rem solid #e0e0e0;
    border-radius: 0.75rem;
    padding: 0.75rem 0.875rem;
    cursor: pointer;
    text-align: left;
    text-decoration: none;
    flex: 1;
    min-width: 0;
    transition:
        border 0.2s ease,
        box-shadow 0.2s ease;
    font-family: inherit;
    position: relative;
    z-index: 1;

    &:disabled {
        cursor: not-allowed;
        background: white;
        border-style: none;
        border-radius: 0.625rem;
    }

    &:hover:not(:disabled) {
        border-color: #999;
        box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.1);
    }
`

export const Destination = styled.h3`
    font-size: 1rem;
    font-weight: 600;
    margin: 0 0 0.5rem;
    color: #1a1a1a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        font-size: 1.125rem;
    }
`

export const Details = styled.p`
    font-size: 0.8125rem;
    color: #666;
    margin: 0;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        font-size: 0.875rem;
    }
`

export const GuestsLabel = styled.p`
    font-size: 0.8125rem;
    color: #666;
    margin: 0;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0.5rem 0 0 0;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        font-size: 0.875rem;
    }
`
